import { Country } from './country.js';
import { TimeZoneRegion } from './time-zone-region.js';

// ISO ISO 639-1 codes for all the supported languages.
// For more information see: https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
export enum Language {
  English = 'en',
  Hungarian = 'hu',
  Romanian = 'ro'
}

const languageOfCountry = new Map<Country, Language>([
  [Country.Hungary, Language.Hungarian],
  [Country.Romania, Language.Romanian],
]);

const languageOfTimeZone = new Map<TimeZoneRegion, Language>([
  [TimeZoneRegion.EuropeBudapest, Language.Hungarian],
  [TimeZoneRegion.EuropeBucharest, Language.Romanian],
]);

export function getLanguageOfCountry(country: Country): Language | null {
  return languageOfCountry.get(country) ?? null;
}

export function getLanguageOfTimeZone(timezone: TimeZoneRegion): Language | null {
  return languageOfTimeZone.get(timezone) ?? null;
}
